/* eslint-disable import/prefer-default-export */
import {get} from 'lodash';
import formatOer from '../formatter';

export const isMobile = state => get(state, 'configuration.isMobile', true);

export const filterHiddensOERs = (state, oers = 'libraryFilters.oerTypes') => {
  const excludedOers = get(state, 'customer.data.excludedOers', []);
  const oerTypes = get(state, oers, []);
  const filteredOerTypes = [];
  for (let i = 0; i < oerTypes.length; i++) {
    const oer = oerTypes[i];
    if (excludedOers.indexOf(oer.id) === -1) {
      filteredOerTypes.push({...oer, name: formatOer(oer.name)});
    }
  }

  return filteredOerTypes;
};
